<template>
  <div id="credit-header" class="credit-header i-mb-13">
    <div class="title-section">
      <div class="d-flex flex-column title-section__wrapper">
        <div class="d-flex i-mb-2 title-section__main i-gap-sm">
          <h1 class="i-text-heading-4 i-m-0">Credit Insights</h1>
          <div
            role="button"
            data-testid="confidence-score-button"
            :aria-label="confidenceScoreLabel"
            data-dd-action-name="credit-confidence-score"
            class="title-section__button"
            @click="toggleFAQModal"
          >
            <i-badge
              :colour="
                lowConfidenceScore ? iBadgeColours.ERROR : iBadgeColours.SUCCESS
              "
              interactable
              :label="confidenceScoreLabel"
              has-trailing-icon
              icon="small-arrows-right-small"
              @right-icon-click="toggleFAQModal"
            />
          </div>
        </div>
        <p class="i-text-body-2 i-text-neutral-110">
          View the customer’s Credit Insights across all their bank accounts
        </p>
      </div>
      <div class="d-flex">
        <credit-header-date />
        <credit-insights-reconciled-docs-filter
          v-if="creditReconciledDocsFilterEnabled"
        />
        <credit-insights-export-button
          data-testid="credit-insights-export-button"
        />
        <button
          v-if="creditAgentEnabled"
          class="title-section__belle i-ml-4"
          @click="toggleAgentModal"
        >
          <img src="../../../img/belle.svg" alt="Credit Agent Icon" />
        </button>
      </div>
    </div>

    <credit-faq-modal
      :is-showable="showFAQModal"
      @hide-faq-modal="toggleFAQModal"
    ></credit-faq-modal>
    <credit-agent-modal
      :is-showable="showAgentModal"
      @hide-faq-modal="toggleAgentModal"
    ></credit-agent-modal>
  </div>
</template>

<script>
import { iBadge, iBadgeColours } from '@inscribe/signal';
import CreditHeaderDate from '@/V2/credit/components/CreditHeaderDate';
import CreditFaqModal from '@/V2/credit/components/CreditFAQModal';
import CreditAgentModal from '@/V2/credit/components/CreditAgentModal';
import CreditInsightsExportButton from '@/V2/credit/components/CreditInsightsExportButton';
import CreditInsightsReconciledDocsFilter from '@/V2/credit/components/CreditInsightsReconciledDocsFilter';
import { mapGetters } from 'vuex';

export default {
  name: 'CreditHeader',
  components: {
    CreditFaqModal,
    CreditAgentModal,
    CreditHeaderDate,
    CreditInsightsExportButton,
    CreditInsightsReconciledDocsFilter,
    iBadge,
  },
  props: {
    lowConfidenceScore: {
      type: Boolean,
      default: false,
    },
    lowTrustScore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iBadgeColours,
      showFAQModal: false,
      showAgentModal: false,
      onlyUseReconciledDocuments: false,
    };
  },
  computed: {
    ...mapGetters({
      creditDisableTrustScoreAlert: 'creditDisableTrustScoreAlert',
      creditReconciledDocsFilterEnabled: 'creditReconciledDocsFilterEnabled',
      creditAgentEnabled: 'creditAgentEnabled',
    }),
    displayTrustScoreAlert() {
      return this.lowTrustScore && this.creditDisableTrustScoreAlert === false;
    },
    confidenceScoreLabel() {
      return `Inscribe Confidence Score: ${
        this.lowConfidenceScore ? 'Low' : 'High'
      }`;
    },
  },
  methods: {
    toggleFAQModal() {
      this.showFAQModal = !this.showFAQModal;
    },
    toggleAgentModal() {
      this.showAgentModal = !this.showAgentModal;
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-header {
  .title-section {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include respond-to('medium') {
      flex-direction: column;
      align-items: flex-start;
    }

    &__wrapper {
      @include respond-to('medium') {
        width: 100%;
      }
    }
    &__date {
      @include respond-to('medium') {
        margin-top: 16px;
      }
    }
    &__main {
      @include respond-to('small') {
        flex-direction: column;
      }
    }
    &__button {
      @include respond-to('small') {
        display: flex;
        margin-bottom: 8px;
      }
    }
    &__belle {
      border: 0;
      background-color: transparent;
      width: 40px;
      height: 40px;
      animation: pulse 1s infinite;
      img {
        width: 50px;
        height: 50px;
        transform: translate(-10px, -2px);
      }
    }
    @keyframes pulse {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}
</style>
